export default '/category/*'
